import { createContext } from "react";

export const ArticulosMedidasContext = createContext()
export const ArticulosMedidasFormContext = createContext()
export const ArticulosMedidasReportContext = createContext()